export enum PollutingEmissionsDemoGroupType {
    FIRSTGROUP = 'FIRSTGROUP',
    SECONDGROUP = 'SECONDGROUP'
}
